import { activateTab, setEventHandlerAndScroll } from '../../util';
import { ACTIVE_ITEMS_CLASS } from '../../constant';
import Depth4Tab from './Depth4Tab';

export default class Depth3Tab {
    private $depth3List =
        document.querySelector<HTMLDivElement>('.depth3-list')!;
    private depth3ActivatedTabIndex: number = -1;
    private $depth3ActivatedTab: HTMLSpanElement | null = null;
    private $depth3TabListItems =
        document.querySelectorAll<HTMLSpanElement>('.depth3-list-items');
    private depth4: Depth4Tab;

    constructor() {
        this.depth4 = new Depth4Tab();
        this.activeTabs();
        this.setDepthEvents();
    }
    private activeTabs(): void {
        // depth4 활성화 후 depth3활성화
        this.depth4.activeTab(this.activeTab.bind(this));
        if (!this.$depth3ActivatedTab) this.activeTab();
    }
    private setDepthEvents(): void {
        this.setDepthEvent();
        this.depth4.setDepthEvent();
    }
    // 활성화 시킬 탭 찾기
    public activeTab(compareUrlInDepth4?: string): void {
        activateTab(
            this.$depth3TabListItems,
            this._activeDepth3.bind(this),
            compareUrlInDepth4
        );
    }
    private _activeDepth3($depth3Element: HTMLSpanElement, index: number) {
        $depth3Element.classList.add(ACTIVE_ITEMS_CLASS);
        this.$depth3ActivatedTab = $depth3Element;
        this.depth3ActivatedTabIndex = index;
    }
    // scroll, resize 이벤트 등록
    public setDepthEvent(): void {
        if (!this.$depth3List || !this.$depth3ActivatedTab) return;
        setEventHandlerAndScroll(
            this.$depth3List,
            this.$depth3ActivatedTab,
            this.depth3ActivatedTabIndex
        );
    }
}
